import { Component, Emit, Prop, Ref, Vue, Watch } from 'vue-property-decorator';
import "@/plugins/googleMaps";
import Experience from '@/models/experience';
import SwiperCarousel from '@/components/SwiperCarousel.vue';
import GenericCard from '@/components/stateless/GenericCard.vue';

declare const google: any;

interface ExperienceMarker {
  title: string;
  id: string;
  lat: number;
  lng: number;
  experiences: Experience[];
  icon: {
    url: any,
    size: { width: number, height: number, f: string, b: string }
    scaledSize: { width: number, height: number, f: string, b: string }
  }
}

export interface Bounds {
  east: number,
  north: number,
  south: number,
  west: number,

  [k: string]: number //shut up tslint
}

@Component({
  components: { GenericCard, SwiperCarousel }
})
export default class ExperienceMap extends Vue {
  @Prop({ default: false }) private loading: boolean = false;
  @Prop({ default: () => [] }) private experiences!: Experience[];
  @Prop({ default: false }) private zoomUnlocked!: boolean;
  @Ref('experience-map') vueMap: any;
  mapStyles = []
  private fitRequested: boolean = false;

  @Emit() boundsChanged(bounds: { east: number, north: number, south: number, west: number }) {
    return bounds;
  }

  @Emit() experienceClicked(experience: Experience) {
    return experience;
  }

  private markers: {
    [id: string]: ExperienceMarker;
  } = {};

  // @ts-ignore
  private selectedMarker?: ExperienceMarker = null;
  private infoWindowVisible: boolean = false;

  private styles = [
    {
      height: 35,
      url: require("@/assets/icons/markerClusterIcon.png"),
      width: 35
    },
    {
      height: 35,
      url: require("@/assets/icons/markerClusterIcon.png"),
      width: 35
    },
    {
      height: 35,
      url: require("@/assets/icons/markerClusterIcon.png"),
      width: 35
    },
    {
      height: 35,
      url: require("@/assets/icons/markerClusterIcon.png"),
      width: 35
    },
    {
      height: 35,
      url: require("@/assets/icons/markerClusterIcon.png"),
      width: 35
    }
  ]

  @Watch('experiences')
  async onExperiencesChanged(experiences: Experience[]) {
    await this.mapExperiencesToMarkers(experiences.filter(e => {
      const expType = e.experienceTypeTags.find((it: any) => it.categoryId === 'exptype')
      return expType && expType.code !== 'smart'
      })
    );
    if (this.fitRequested) this.calculateAndFitBounds();
  }

  async mounted() {
    if (this.experiences && this.experiences.length) {
      await this.mapExperiencesToMarkers(this.experiences);
      if (this.fitRequested) this.calculateAndFitBounds();
    }
  }

  fit() {
    if (Object.keys(this.markers).length == 0) {
      this.fitRequested = true;
    } else this.calculateAndFitBounds();
  }


  calculator(
    markers: any[],
    numStyles: number
  ): any {
    return {
      text: '',
      index: 0,
      title: ""
    };
  }

  calculateAndFitBounds() {
    this.fitRequested = false;
    const bounds = new google.maps.LatLngBounds();
    for (const k of Object.keys(this.markers)) {
      const marker = this.markers[k];
      bounds.extend(marker);
    }
    this.vueMap.$mapPromise
        .then((map: any) => {
          map.fitBounds(bounds)
        });
  }

  async mapExperiencesToMarkers(experiences: Experience[]) {
    const iconUrl = require("@/assets/icons/markerIconWhite.svg"),
          iconIBUrl = require("@/assets/icons/markerIconWhiteIB.svg"),
          iconManyUrl = require("@/assets/icons/markerIconWhiteMany.svg"),
          iconManyIBUrl = require("@/assets/icons/markerIconWhiteManyIB.svg"),
          icon    = {
            url: iconUrl,
            size: { width: 35, height: 35, f: "px", b: "px" },
            scaledSize: { width: 35, height: 35, f: "px", b: "px" }
          },
          iconIB    = {
            url: iconIBUrl,
            size: { width: 42, height: 42, f: "px", b: "px" },
            scaledSize: { width: 42, height: 42, f: "px", b: "px" }
          },
          iconMany    = {
            url: iconManyUrl,
            size: { width: 35, height: 35, f: "px", b: "px" },
            scaledSize: { width: 35, height: 35, f: "px", b: "px" },
            labelOrigin: new google.maps.Point(35/2, 35/2 -2)
          },
          iconManyIB    = {
            url: iconManyIBUrl,
            size: { width: 42, height: 42, f: "px", b: "px" },
            scaledSize: { width: 42, height: 42, f: "px", b: "px" },
            labelOrigin: new google.maps.Point(42/2, 42/2 +2),
          };

    this.markers = experiences.reduce((markers, experience) => {
        const cellar = experience.cellar;
        if (!cellar || !cellar.id || !cellar.address || !cellar.address.lat || !cellar.address.lng) return markers;
        const marker: ExperienceMarker = markers[cellar.id] || {
          id: cellar.id,
          experiences: [],
          icon: experience.instantBooking ? iconIB : icon,
          lat: parseFloat(cellar.address.lat),
          lng: parseFloat(cellar.address.lng),
          title: cellar.title
        }
        marker.experiences.push(experience);
        markers[cellar.id] = marker;
        if (marker.experiences.length > 1) {
          if(marker.experiences.filter(e => e.instantBooking).length)
            marker.icon = iconManyIB;
          else
            marker.icon = iconMany;
        }
        return markers;
      }
      , {} as any);
  }

  async markerClicked(marker: ExperienceMarker) {
    this.infoWindowVisible = false;
    const map = await this.vueMap.$mapPromise;
    map.panTo(marker);
    setTimeout(() => {
      this.selectedMarker = marker;
      this.infoWindowVisible = true;
    }, 100)
  }


  async emitBounds() {
    const map = await this.vueMap.$mapPromise;
    const bounds = map.getBounds();
    if (!bounds) return;
    this.boundsChanged(bounds.toJSON());
  }

  async dragEnd() {
    await this.emitBounds();
  }

  async mapZoom() {
    if (!this.zoomUnlocked) return;
    await this.emitBounds();
  }
}
